import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
    Alert,
    Card,
    CardBody,
    CardFooter,
    Col,
    Row
} from 'reactstrap';
import Notification from '../notification/Notification';
import FalconCardHeader from '../common/FalconCardHeader';
import { isIterableArray } from '../../helpers/utils';
import { Or, PreloadState } from '../UI/preloading/PreloadState';
import { fetchNotifications, markNotificationsAsRead } from '../../helpers/api/notifications';
import { useHistory } from 'react-router';
import moment from 'moment';
import useSWRFetchPagination from '../../helpers/hooks/useSWRFetchPagination';
import FullPagination from '../common/pagination/FullPagination';
import { SUCCESS_RESPONSE } from '../../helpers/codeResponses/codes';
import handleErrorMessage from '../../helpers/errors/handleErrorMessage';
import { buildRewardsNotificationContent, getRewardsNotificationView, isRewardsNotification } from '../rewards/rewardsNotifications';
import { REWARDS_ENABLED } from '../../helpers/rewardsEnabled';

const Notifications = ({ children }) => {
    const [submitting, setSubmitting] = useState(false);
    const history = useHistory();
    const {
        data,
        isLoading,
        mutate,
        meta,
        handler: { nextPage, previousPage, perPage, goToPage }
    } = useSWRFetchPagination(fetchNotifications);

    const markAsReadAll = () => {
        setSubmitting(true);
        markNotificationsAsRead()
            .then(({ code }) => {
                if (code === SUCCESS_RESPONSE.OK) {
                    mutate();
                }
            })
            .catch(error => { console.log(error) })
            .finally(() => { setSubmitting(false) })
    }

    const markAsRead = (type, id, typeId, params = null) => {
        setSubmitting(true);
        markNotificationsAsRead(id)
            .then(({ code }) => { if (code === SUCCESS_RESPONSE.OK) mutate(); })
            .catch(error => { handleErrorMessage(error) })
            .finally(() => {
                setSubmitting(false); history.push({
                    // HO-TASK-290: las de Homelan Rewards llevan a la ruta de su tipo.
                    pathname: isRewardsNotification(type) ? params?.route
                        : type === 'voting' ? `/dashboard/surveys/${typeId}`
                        : (type === 'new-complaint' || type === 'complaint-closed') ? `/dashboard/complaints/${typeId}`
                            : type === 'reserved-common-area' ? `/dashboard/areas/${typeId}/reservations`
                                : type === 'new-debts-to-pay' ? `/dashboard/my/finance/topay/${typeId}`
                                    : type === 'property-payment' ? `/dashboard/finance/${params?.condominium}/payments/${params?.id}`
                                        : type === 'new-ticket' ? `/root/support/${params?.id}`
                                            : type === 'response-ticket' ? `/dashboard/support/${params?.id}`
                                                : '',
                    state: type === 'new-debts-to-pay' ? params : null
                })
            })
    }


    return <>
        <Card className="h-100">
            <FalconCardHeader title="Tus notificaciones">
                <div className="fs--1">
                    <Link className="text-sans-serif" to="#!" onClick={() => markAsReadAll()}>
                        Marcar como leídas
                    </Link>
                </div>
            </FalconCardHeader>
            <CardBody className="p-0">
                <PreloadState cond={isIterableArray(data)} loading={isLoading || submitting} message="Cargando...">
                    <Or value={true}>
                        {data.map((notification, index) => {
                            if (!REWARDS_ENABLED && isRewardsNotification(notification.type)) return null;
                            let data = JSON.parse(notification.data);
                            const rewards = getRewardsNotificationView(notification);
                            if (rewards) {
                                return (
                                    <Notification key={index} emoji={rewards.emoji} time={moment(notification.created_at).fromNow()} content={buildRewardsNotificationContent(rewards)} onClick={() => markAsRead(notification.type, notification.id, null, { route: rewards.route })} flush unread={!notification.read_at} />
                                )
                            }
                            return (
                                <Notification key={index} emoji={'🔔'} time={moment(notification.created_at).fromNow()} content={`${data?.message} ${data?.data?.title ? data?.data?.title : ''}`} onClick={() => markAsRead(notification.type, notification.id, notification.type === 'reserved-common-area' ? data.data.common_area.id : data?.data?.id, notification.type === 'new-debts-to-pay' ? { amount: data.data.amount, date: data.data.created_at, propertyDebtId: data.data.id, aliquot: data.data.aliquot, paymented: false, total_paid: 0 } : notification.type === 'property-payment' ? { condominium: data.data.property_debts.property.condominium.id, id: data.data.id } : notification.type === 'new-ticket' ? { id: data.data.id } : notification.type === 'response-ticket' ? { id: data.data.ticket_id } : null)} flush unread={!notification.read_at} />
                            )
                        })}
                    </Or>
                    <Or value={false}>
                        <Row className="p-card">
                            <Col>
                                <Alert color="info" className="mb-0 fs--1">
                                    No hay notificaciones para mostrar.
                                </Alert>
                            </Col>
                        </Row>
                    </Or>
                </PreloadState>
            </CardBody>
            {children}
            <CardFooter>
                {isIterableArray(data) &&
                    <FullPagination
                        nextPage={nextPage}
                        prevPage={previousPage}
                        goToPage={goToPage}
                        meta={meta}
                        className={'shadow-none'}
                        posText={"notificaciones"}
                        perPage={perPage}
                    />
                }
            </CardFooter>
        </Card>
    </>
}

Notifications.propTypes = {
    items: PropTypes.number,
    children: PropTypes.node
};

export default Notifications;